export default __webpack_public_path__ + "static/media/settings.924a7bdd.svg";